import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './../../services/spinner.service';

@Component({
  selector: 'a2z-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  showSpinner: any;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.showSpinner = this.spinnerService.visibility;
  }

}
